/**
 * WI 35277: event the host raises (DynamicRenderService.retryFailedLookups) to make every
 * typeahead whose saved-value lookup failed run it again. Kept out of DynamicEventBusTypes
 * on purpose: that object's type is quoted inside other compiler errors.
 */
export const DYNAMIC_RETRY_LOOKUPS_EVENT = 'dynamicRetryLookups';
